import styled from 'styled-components';

export const CardWrapper = styled.div`
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  .card-content {
    border-radius: 16px;
    font-family: neueMontreal-Regular;
    margin-top: 22px;
  }
  .card-main {
    border: 1px solid hsla(0, 0%, 67%, 0.502);
    border-radius: 16px;
    font-family: neueMontreal-Regular;
    margin-top: 22px;
    padding: 24px 16px;
  }
`;

export const CardContentHolder = styled.div<{ placing?: boolean }>`
  }
  & > div {
    flex: 1 1 300px;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;

export const CustomWidgetHeader = styled.div`
  padding-bottom: 10px;
  margin-bottom: 10px;
  align-items: end;
  display: flex;
  justify-content: space-between;
  h2 {
    font-size: 1.2em;
    margin: 0;
  }
  a {
    color: #001316;
    font-size: 12px;
    font-weight: 500;
    text-decoration: underline;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  tbody tr {
    border-bottom: 1px dotted #eee;
    &:last-child {
      border-bottom: none;
    }
    td {
      padding: 8px 0;
      &:first-child {
        width: 70%;
      }
      text-align: left;
      &:last-child {
        text-align: right;
      }
      a {
        text-decoration: none;
        color: #333;
        &:hover {
          color: #007bff;
        }
      }
      p.price-value {
        margin: 0;
        font-weight: bold;
        color: #0056b3;
      }
      p {
        margin: 5px 0 0;
        font-size: 0.9em;
        span {
          font-weight: normal;
        }
      }
      p.positive {
        color: #28a745;
      }
      p.negative {
        color: #dc3545;
      }
    }
  }
`;
